module.exports = __webpack_public_path__ + "static/img/SS.2cac792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SS.png
// module id = 6c4N
// module chunks = 18